import React from 'react';
import Icon from '../../../components/AppIcon';


const RecommendationCard = ({ recommendation, isSaved, onSave }) => {
  const getImpactColor = (impact) => {
    if (impact === 'high') return '#10B981';
    if (impact === 'medium') return '#F59E0B';
    return '#6B7280';
  };

  const getCategoryIcon = (category) => {
    const icons = {
      lighting: 'Sun',
      composition: 'Frame',
      expression: 'Smile',
      styling: 'Sparkles'
    };
    return icons?.[category] || 'Lightbulb';
  };

  return (
    <div className="bg-card rounded-xl p-4 sm:p-6 border border-border hover:shadow-warm-md transition-all active:scale-[0.98]">
      <div className="flex items-start justify-between gap-3 sm:gap-4 mb-4">
        <div className="flex items-start gap-2.5 sm:gap-3 flex-1">
          <div className="bg-muted rounded-full p-2.5 sm:p-2 flex-shrink-0">
            <Icon name={getCategoryIcon(recommendation?.category)} size={20} color="var(--color-primary)" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-2">
              <h4 className="font-semibold text-foreground text-base sm:text-base">{recommendation?.title}</h4>
              <span
                className="text-xs font-medium px-2.5 py-1 rounded-full inline-block w-fit"
                style={{
                  backgroundColor: `${getImpactColor(recommendation?.impact)}20`,
                  color: getImpactColor(recommendation?.impact)
                }}
              >
                {recommendation?.impact?.toUpperCase()} IMPACT
              </span>
            </div>
            <p className="text-sm sm:text-sm text-muted-foreground leading-relaxed">
              {recommendation?.description}
            </p>
          </div>
        </div>
        <button
          onClick={onSave}
          className="flex-shrink-0 p-2.5 sm:p-2 hover:bg-muted rounded-lg transition-colors active:scale-95 min-w-[44px] min-h-[44px] sm:min-w-[36px] sm:min-h-[36px] flex items-center justify-center"
          aria-label={isSaved ? 'Remove bookmark' : 'Add bookmark'}
        >
          <Icon
            name={isSaved ? 'BookmarkCheck' : 'Bookmark'}
            size={20}
            color={isSaved ? 'var(--color-primary)' : 'var(--color-muted-foreground)'}
          />
        </button>
      </div>
      <div className="flex items-center gap-2 text-xs sm:text-xs text-muted-foreground">
        <Icon name="Tag" size={14} color="var(--color-muted-foreground)" />
        <span className="capitalize">{recommendation?.category}</span>
      </div>
    </div>
  );
};

export default RecommendationCard;